import type { PartialTranslations } from "../types";

export const zh: PartialTranslations = {
	auth: {
		login: {
			headline: "讲述你的故事。",
			subheadline: "登录，从上次离开的地方继续。",
			emailPlaceholder: "你的邮箱",
			passwordPlaceholder: "密码",
			submitIdle: "登录",
			submitLoading: "登录中...",
			noAccount: "还没有账户？",
			beginHere: "从这里开始。",
			errorInvalid: "邮箱或密码无效。",
			errorGeneric: "出了点问题，请重试。",
		},
		register: {
			headline: "从这里开始。",
			subheadline: "每个故事都有开始。",
			namePlaceholder: "你的名字",
			emailPlaceholder: "你的邮箱",
			passwordPlaceholder: "选择一个密码",
			submitIdle: "创建账户",
			submitLoading: "创建中...",
			alreadyHaveAccount: "已有账户？",
			signIn: "登录。",
			errorConflict: "该邮箱已注册。",
			errorGeneric: "出了点问题，请重试。",
		},
	},
	stories: {
		list: {
			headline: "你的故事。",
			beginNew: "开始新故事。",
			loading: "加载中...",
			errorLoad: "无法加载故事，请刷新页面。",
			empty: "你还没有写任何东西。",
			noTag: '没有标记为"{{tag}}"的故事。',
			filterBy: "按标签筛选",
			clearFilter: "清除筛选",
			showAll: "显示全部故事",
			storiesCount_one: "{{count}} 篇故事",
			storiesCount_other: "{{count}} 篇故事",
			filteredCount: "显示 {{filtered}} / {{total}}",
			searchPlaceholder: "搜索你的故事…",
			sortNewest: "最新优先",
			sortOldest: "最早优先",
			pageOf: "第 {{page}} / {{pages}} 页",
			noResults: "没有符合搜索条件的故事。",
		},
		new: {
			back: "← 返回",
			titlePlaceholder: "给它起个名字，或留空。",
			voicePrompt: "像跟朋友聊天一样讲述你的故事，不完美没关系。",
			switchToText: "改用文字 →",
			writePrompt: "像跟朋友讲一样写出来，不完美没关系。",
			switchToVoice: "← 改用语音",
			modeText: "书写",
			modeVoice: "说话",
			submitIdle: "发送。",
			submitLoading: "发送中...",
			errorGeneric: "出了点问题，请重试。",
		},
		card: {
			untitled: "无标题故事",
			status: {
				processing: "处理中...",
				awaiting_response: "等待你的回复",
				done: "已审阅",
				failed: "失败",
			},
		},
		detail: {
			loading: "加载中...",
			notFound: "未找到故事。",
			processing: {
				reading: "倾听中…",
				transcribing: "正在理解内容…",
			},
			failed: {
				heading: "出了点问题",
				explanation:
					"处理你的故事时出了点问题。你可以重试——原始录音已安全保存。",
				tryAgain: "重试",
				retrying: "重试中…",
			},
			coaching: {
				akinNotes: "Akin 的笔记",
				showNote: "显示{{label}}",
				questionStep: "第 {{step}} / {{total}} 题",
				takeYourTime: "慢慢来...",
				switchToVoice: "← 改用语音",
				switchToText: "改用文字 →",
				back: "← 返回",
				next: "下一步",
				skip: "跳过",
				doneSendAnswers: "完成 — 发送答案",
				reviewAndSubmit: "审阅并提交",
				uploading: "上传中…",
				imDone: "我已完成这个故事。",
				imDoneConfirm: "这将把你的故事标记为已完成，确定吗？",
				imDoneYes: "是的，标记为完成",
				imDoneCancel: "继续",
				transcribing_one: "正在转录 {{count}} 个答案…",
				transcribing_other: "正在转录 {{count}} 个答案…",
				transcriptionFailed: "转录失败 — 请输入你的答案",
				transcriptionFailedNote: "转录失败 — 请输入或留空。",
				leaveBlank: "留空跳过",
				submit: "提交",
				submitting: "发送中…",
				voiceUploadFailed: "部分语音答案无法上传，请在下方输入文字。",
				retryVoiceUpload: "重试上传",
			},
			transcriptionPreview: {
				heading: "这是我们听到的内容",
				noTranscription: "暂无转录内容。",
				editTranscription: "编辑转录",
				cancel: "取消",
				save: "保存",
				saving: "保存中…",
				looksGood: "看起来不错 — 继续",
				starting: "启动中…",
			},
			storyUpdate: {
				roundComplete: "第 {{number}} 轮完成",
				akinNotes: "Akin 的笔记",
				titlePlaceholder: "给它起个名字，或留空。",
				storyPlaceholder: "你的故事将显示在这里...",
				saveChanges: "保存更改",
				saving: "保存中…",
				keepGoing: "继续",
				imDone: "我已完成这个故事。",
			},
			done: {
				akinNotes: "Akin 的笔记",
				backToStories: "← 我的故事",
				yourRecording: "你的录音",
				copyText: "复制文本",
				copied: "已复制。",
				answerQuestionsAgain: "再次回答问题",
				starting: "启动中…",
				beginNew: "开始新故事",
				edit: "编辑",
				cancel: "取消",
				saveChanges: "保存更改",
				saving: "保存中…",
				recordStory: "录制你的故事",
				deleteStory: "删除故事",
			},
			deleteConfirm: {
				heading: "删除这个故事？",
				body: "此操作无法撤销。故事及其所有历史记录将被永久删除。",
				confirm: "是的，删除",
				cancel: "取消",
				deleting: "删除中…",
			},
			rerecord: {
				eyebrow: "还有一件事",
				heading: "再讲一次，现在你记得更多了。",
				body: "你已经做了最难的回忆工作。这是你用自己的声音、带着所有细节，重新录下这个故事的机会。",
				modeReadTitle: "朗读出来",
				modeReadDesc:
					"我们会显示精炼后的故事供你按自己的节奏朗读。适合想要听起来更精致的情况。",
				modeRetellTitle: "用自己的话讲述",
				modeRetellDesc:
					"不需要台本，只有你和现在记得的一切。适合想要听起来更像你自己的情况。",
				startRecording: "开始录音",
				saveRecording: "保存这段录音",
				saving: "保存中…",
				skipNow: "先跳过，以后再说",
				teleprompterLabel: "你的故事",
				error: "出了点问题，请重试。",
				uploadFailed: "你的录音无法保存。",
				retryUpload: "重试上传",
			},
		},
	},
	profile: {
		headline: "你的个人资料。",
		back: "← 返回",
		email: "邮箱",
		name: "姓名",
		edit: "编辑",
		save: "保存",
		saving: "保存中…",
		cancel: "取消",
		changePassword: "修改密码",
		currentPassword: "当前密码",
		newPassword: "新密码",
		passwordUpdated: "密码已更新。",
		signOut: "退出登录",
		memberSince: "加入于 {{date}}",
		storiesCount_one: "已写 {{count}} 篇故事",
		storiesCount_other: "已写 {{count}} 篇故事",
		errorPasswordWrong: "当前密码不正确。",
		errorGeneric: "出了点问题，请重试。",
	},
	audio: {
		startRecording: "开始录音",
		stopRecording: "停止录音",
		tapToRecord: "点击录音",
		tapToStop: "点击停止",
		reRecord: "重新录音",
		ready: "准备好 ✓",
		micDenied: "麦克风访问被拒绝，请在浏览器设置中允许。",
	},
	tags: {
		ariaLabel: "故事标签",
		removeTag: "移除标签 {{tag}}",
		placeholder: "标签名称…",
		addTag: "+ 标签",
	},
	onboarding: {
		intro: {
			skip: "跳过",
			alreadyHaveAccount: "已有账户？",
			logIn: "登录。",
			screens: [
				{
					headline: "每个生命都是一座图书馆。",
					body: "不是精心策划的版本。是真实的——那些气味、错误、饭食，那些只有你记得的瞬间。",
					cta: "下一步 →",
				},
				{
					headline: "Akin 帮你讲述它。",
					body: "你说、你写，或者只是回忆。Akin 倾听，问出恰当的问题，把你所说的塑造成值得珍藏的东西。",
					cta: "下一步 →",
				},
				{
					headline: "你的第一个故事，现在开始。",
					body: "它不必完美，只要真实。",
					cta: "开始 →",
				},
			],
		},
		prompts: {
			eyebrow: "你的第一个故事",
			headline: "你想记住什么？",
			subtext: "选择一个感觉合适的。",
			note: "你可以随时探索更多提示。现在，选择一个感觉合适的。",
			cta: "开始录制 →",
		},
		celebration: {
			eyebrow: "你的第一个故事",
			headline: "已保存。",
			body: "你的第一个故事已保存。准备好了，随时可以继续。",
			cta: "前往你的档案 →",
		},
	},
	home: {
		welcome: "欢迎，{{name}}。",
		beginNewStory: "开始新故事",
		loading: "加载中…",
		error: "出了点问题，请刷新页面。",
		todaysPrompt: "今日提示",
		recentStories: "近期故事",
		untitled: "无标题",
		stillTellingMany: "还有 {{count}} 个未完成的故事",
		continue: "继续",
		record: "录音",
		write: "写作",
		anotherPrompt: "换一个提示",
		startWithoutPrompt: "直接开始，不用提示",
		storiesEmpty: "你的故事，将在这里留存。",
		viewAll: "查看全部故事",
		totalStories_one: "{{count}} 篇故事 →",
		totalStories_other: "{{count}} 篇故事 →",
		encouragement: {
			line0: "你正在构建真实的东西。",
			line1: "这周三篇，继续加油。",
			line2: "这些故事永远属于你。",
			line3: "一段值得铭记的人生，一个故事接一个故事。",
			line4: "这里的每一个字都有意义。",
			withCount: "本周 {{count}} 篇故事。{{line}}",
		},
	},
};
